import React from 'react';
import { useNavigate } from 'react-router-dom'; // 👈 Importar useNavigate
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faHandshake, faCheck } from '@fortawesome/free-solid-svg-icons';
import './Financiacion.css';

export default function Financiacion() {
    // 1. Inicializar la función de navegación
    const navigate = useNavigate();

    const pasos = [
        {
            numero: 1,
            icon: faSearch,
            titulo: "Elegís la moto que te gusta",
            descripcion: "Visitá nuestro catálogo para ver tu moto ideal."
        },
        {
            numero: 2,
            icon: faHandshake,
            titulo: "Nos contactás y te asesoramos",
            descripcion: "Gestionamos el crédito más accesible según tu caso."
        },
        {
            numero: 3,
            icon: faCheck,
            titulo: "¡Felicitaciones!",
            descripcion: "Hacemos los trámites y te vas en tu moto nueva."
        }
    ];

    const handleFinanciarClick = () => {
        console.log('Iniciando proceso de financiación. Navegando a /financiacion');
        // 2. Usar navigate para cambiar la ruta
        navigate('/financiacion');
        // NOTA: 'http://localhost:3000' es la base de tu desarrollo,
        // al usar navigate('/financiacion') React Router lo hace automáticamente.
    };

    return (
        <div className='financiacion-section'>
            <div className='financiacion-container'>
                <div className='financiacion-header'>
                    <h2 className='financiacion-title'>FINANCIA TU MOTO</h2>
                    <p className='financiacion-subtitle'>
                        Gestionamos créditos de forma fácil y a la tasa más conveniente.
                    </p>
                </div>

                <div className='pasos-grid'>
                    {pasos.map((paso, index) => (
                        <div
                            key={index}
                            className='paso-item'
                            style={{ '--delay': `${index * 0.2}s` }}
                        >
                            <div className='paso-numero'>
                                <span>{paso.numero}</span>
                            </div>
                            <div className='paso-icon-container'>
                                <FontAwesomeIcon icon={paso.icon} className='paso-icon' />
                            </div>
                            <div className='paso-content'>
                                <h3 className='paso-titulo'>{paso.titulo}</h3>
                                <p className='paso-descripcion'>{paso.descripcion}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className='financiacion-cta'>
                    <button
                        className='financiar-btn'
                        onClick={handleFinanciarClick} // 👈 Se llama a la función modificada
                    >
                        Quiero financiar mi moto
                        <span className='btn-arrow'>→</span>
                    </button>
                </div>
            </div>
        </div>
    );
}